import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "error" }
const _hoisted_2 = {
  key: 0,
  class: "text-center error"
}
const _hoisted_3 = ["href"]

import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/shared/Modal.vue";
import NextButton from "@/components/shared/NextButton.vue";
import CircleLoader from "@/components/shared/CircleLoader.vue";
import PelLoanConfigurationDetailsSection from "@/components/pel-loan-configuration/PelLoanConfigurationDetailsSection.vue";
import LocLoanConfigurationDetailsSection from "@/components/loan-configuration/LocLoanConfigurationDetailsSection.vue";
import { ProductIds } from "@/config/constants";
import useEsignConfirmation from "@/composables/useEsignConfirmation";
import useApplicationData from "@/composables/useApplicationData";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmYourLoanDetailsModal',
  emits: ["close", "openLoanConfigurationModal", "openSchoolConfirmationModal", "openBorrowAmountModal", "openLoanOptionsModal"],
  setup(__props, { emit: __emit }) {

const store = useStore();

const emit = __emit;

const error = ref<boolean>(false);

const { emailAddress, isPel, productTypeId } = useApplicationData();

const { confirmChanges, esignResponseError, gettingData, loading } = useEsignConfirmation();

const product = computed<string>(() => {
  return productTypeId.value === ProductIds.LOC ? "Line of Credit" : "Loan";
});

const detailsSectionComponent = computed(() => {
  return isPel.value ? PelLoanConfigurationDetailsSection : LocLoanConfigurationDetailsSection;
});

const modalEventListeners = computed(() => {
  switch (detailsSectionComponent.value) {
    case PelLoanConfigurationDetailsSection:
      return {
        openLoanConfigurationModal: openLoanConfigurationModal,
        openSchoolConfirmationModal: openSchoolConfirmationModal,
      };
    case LocLoanConfigurationDetailsSection:
      return {
        openLoanConfigurationModal: openLoanConfigurationModal,
        openSchoolConfirmationModal: openSchoolConfirmationModal,
      };
    default:
      return {};
  }
});

const modalProps = computed(() => {
  switch (detailsSectionComponent.value) {
    default:
      return { loading: loading.value };
  }
});

const footerText = computed<string>(() =>
  loading.value
    ? `Your loan documents are being generated and compiled and will soon be ready to sign. Please do not refresh or close your browser during this process. This message will close automatically when your documents are ready.`
    : "By clicking Ready to Sign, you acknowledge that you have reviewed and agree with all the details listed above.",
);

const stepMinHeight = computed(() => {
  switch (loading.value) {
    case true:
      return "200px";
    default:
      return "300px";
  }
});

const styleOptions = computed(() => {
  return {
    modalBody: {
      minHeight: stepMinHeight.value,
    },
  };
});

function closeModal() {
  store.dispatch("applicationInfoModule/closeModal", "ConfirmYourLoanDetails");
}

function openLoanConfigurationModal() {
  emit("openLoanConfigurationModal", true);
}

function openSchoolConfirmationModal() {
  emit("openSchoolConfirmationModal", true);
}

function openBorrowAmountModal() {
  emit("openBorrowAmountModal", true);
}
async function getLocDetails() {
  const response = await store.dispatch(
    "loanConfigurationModule/getPelDetails",
    store.state.appData?.application?.id,
  );

  if (!response) {
    error.value = true;
  }

  gettingData.value = false;
}

onMounted(async () => {
  await getLocDetails();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    closeBtn: true,
    closeBtnHidden: _unref(loading),
    onClose: closeModal,
    styleOptions: styleOptions.value
  }, {
    default: _withCtx(() => [
      (_unref(gettingData) || _unref(loading))
        ? (_openBlock(), _createBlock(CircleLoader, {
            key: 0,
            inline: true
          }))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["confirm-your-loan-details-modal", { loading: _unref(loading) }])
          }, [
            _withDirectives(_createElementVNode("h1", null, "Confirm Your " + _toDisplayString(product.value) + " Details", 513), [
              [_vShow, !_unref(loading)]
            ]),
            _withDirectives(_createElementVNode("p", null, " Before you sign, please review your " + _toDisplayString(product.value.toLowerCase()) + " terms. ", 513), [
              [_vShow, !_unref(loading)]
            ]),
            (_openBlock(), _createBlock(_resolveDynamicComponent(detailsSectionComponent.value), _mergeProps(_toHandlers(modalEventListeners.value), modalProps.value), null, 16)),
            _createElementVNode("div", {
              class: _normalizeClass(["footer", { loading: _unref(loading) }])
            }, [
              _withDirectives(_createElementVNode("p", _hoisted_1, "* Required Fields", 512), [
                [_vShow, !_unref(loading)]
              ]),
              _createElementVNode("p", null, _toDisplayString(footerText.value), 1),
              _createVNode(NextButton, {
                class: "esignButton",
                disabled: _unref(loading),
                loading: _unref(loading),
                text: "Ready to Sign",
                onClick: _withModifiers(_unref(confirmChanges), ["prevent"])
              }, null, 8, ["disabled", "loading", "onClick"])
            ], 2),
            (_unref(esignResponseError))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createTextVNode(" We encountered an error generating your " + _toDisplayString(product.value) + " documents. Our team is working on resolving the situation and will reach out to you within one business day. For additional questions please email ", 1),
                  _createElementVNode("a", {
                    href: `mailto:${_unref(emailAddress)}`
                  }, _toDisplayString(_unref(emailAddress)), 9, _hoisted_3),
                  _cache[0] || (_cache[0] = _createTextVNode(". ", -1))
                ]))
              : _createCommentVNode("", true),
            _cache[1] || (_cache[1] = _createElementVNode("div", null, null, -1))
          ], 2)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(["footer", { loading: _unref(loading) }])
      }, [
        _createElementVNode("p", null, _toDisplayString(footerText.value), 1)
      ], 2), [
        [_vShow, _unref(loading)]
      ])
    ]),
    _: 1
  }, 8, ["closeBtnHidden", "styleOptions"]))
}
}

})